(function (aimi_dashboard_api, $, app, undefined) {

  app.apis['dashboard'] = app.apis['dashboard'] || {};

  app.apis['dashboard'] = function () {
    return {
      'emailEngagementStats': function () {
        return app.getRequest(`/api/mdcdots/email-engagement-stats`, {}, function () {
        }, function () {
        }, '');
      },
      'emailSentStats': function () {
        return app.getRequest(`/api/mdcdots/email-sent-stats`, {}, function () {
        }, function () {
        }, '');
      },
      'leadStats': function () {
        return app.getRequest(`/api/mdcdots/lead-stats`, {}, function () {
        }, function () {
        }, '');
      },
      'socialStats': async function () {
        const behalfOf = await app.getRequest(`/api/mdcdots/behalf-of`, {}, function () {
        }, function () {
        }, '');

        let url = `/api/social/stats`;
        url = Utils.addParamToURL(url, {behalf_of: behalfOf});

        return app.getRequest(url, {}, function () {
        }, function () {
        });
      },
      'fetchByUrl': function (url) {
        return app.getRequest(url, {}, function () {
        }, function () {
        }, '');
      }
    }

  }();

}(window.aimi_dashboard_api = window.aimi_dashboard_api || {}, jQuery, PreBuilt));
